import React from 'react';
import './Chat.css';

interface WidgetProps {
  onClose: () => void;
  className?: string;
}

const Chat: React.FC<WidgetProps> = ({ onClose, className }) => {
  return (
    <div className={`widget-card chat-widget ${className || ''}`}>
      <div className="widget-header">
        <h3>Chat</h3>
        <button onClick={onClose} className="widget-close-btn" aria-label="Chiudi widget Chat">
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="widget-content">
        <p>Sistema di chat interna...</p>
      </div>
    </div>
  );
};

export default Chat; 